var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableView',{attrs:{"headers":[
        { text: 'Title', property: 'title', align: 'left', link: true },
        { text: 'Locale', property: 'locale', align: 'left' },
        { text: 'Created', property: 'created_time_ago', align: 'left' } ],"dialog-text":{
        heading: 'Delete endpoint',
        body: 'Do you really want to delete this endpoint?',
    },"api-base":"endpoints","url-base":"/endpoints","heading":"Endpoints"}})}
var staticRenderFns = []

export { render, staticRenderFns }